module.exports = __webpack_public_path__ + "static/media/attention.2ed7b76d.svg";